module.exports = __webpack_public_path__ + "static/media/igvv.a2e02323.webp";